import React from 'react';

/**
 * LoadingScreen — shown while fetching restaurant data.
 * Displays a simple animated loader.
 */
export default function LoadingScreen() {
  return (
    <div style={styles.container}>
      <div style={styles.spinner}>
        <div style={styles.dot1} />
        <div style={styles.dot2} />
        <div style={styles.dot3} />
      </div>
      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: scale(0); opacity: 0.3; }
          40% { transform: scale(1); opacity: 1; }
        }
        .loading-dot { animation: bounce 1.4s infinite ease-in-out both; }
        .loading-dot:nth-child(1) { animation-delay: -0.32s; }
        .loading-dot:nth-child(2) { animation-delay: -0.16s; }
        .loading-dot:nth-child(3) { animation-delay: 0s; }
      `}</style>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },
  spinner: {
    display: 'flex',
    gap: '8px',
  },
  dot1: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: 'var(--accent)',
    className: 'loading-dot',
    animation: 'bounce 1.4s infinite ease-in-out both',
    animationDelay: '-0.32s',
  },
  dot2: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: 'var(--accent)',
    animation: 'bounce 1.4s infinite ease-in-out both',
    animationDelay: '-0.16s',
  },
  dot3: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: 'var(--accent)',
    animation: 'bounce 1.4s infinite ease-in-out both',
    animationDelay: '0s',
  },
};
